import _default from './Sidebar';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Sidebar/index.js
// module id = 698
// module chunks = 0